import { application } from "../application"
import LoopDemoController from "./loop_demo_controller"
import AppShowcaseController from "./app_showcase_controller"

application.register("loop-demo", LoopDemoController)
application.register("app-showcase", AppShowcaseController)
